import Phaser from 'phaser';

type SfxKey =
  | 'sfx_pick'
  | 'sfx_snap'
  | 'sfx_wrong'
  | 'sfx_victory'
  | 'ui_click'
  | 'ui_confirm'
  | 'ui_open'
  | 'ui_close';

const VOLUME: Record<SfxKey, number> = {
  sfx_pick: 0.25,
  sfx_wrong: 0.35,
  sfx_snap: 0.45,
  sfx_victory: 0.6,
  ui_click: 0.3,
  ui_confirm: 0.35,
  ui_open: 0.25,
  ui_close: 0.25,
};

/**
 * Единая точка воспроизведения SFX.
 * Важно: не раскидывать this.sound.play(...) по коду.
 */
export class SoundManager {
  private scene: Phaser.Scene | null = null;
  private enabled = true;
  private lastPlayAt = new Map<SfxKey, number>();

  bind(scene: Phaser.Scene): void {
    this.scene = scene;
  }

  setEnabled(value: boolean): void {
    this.enabled = value;
  }

  isEnabled(): boolean {
    return this.enabled;
  }

  playPick(): void {
    this.play('sfx_pick');
  }

  playSnap(): void {
    this.play('sfx_snap', 80);
  }

  playWrong(): void {
    this.play('sfx_wrong', 80);
  }

  playVictory(): void {
    this.play('sfx_victory');
  }

  playClick(): void {
    this.play('ui_click', 40);
  }

  playConfirm(): void {
    this.play('ui_confirm');
  }

  playOpen(): void {
    this.play('ui_open');
  }

  playClose(): void {
    this.play('ui_close');
  }

  private play(key: SfxKey, throttleMs = 0): void {
    if (!this.enabled) return;
    const scene = this.scene;
    if (!scene || !scene.sound) return;
    if (!scene.cache.audio.exists(key)) return;

    if (throttleMs > 0) {
      const now = Date.now();
      const last = this.lastPlayAt.get(key) ?? 0;
      if (now - last < throttleMs) return;
      this.lastPlayAt.set(key, now);
    }

    scene.sound.play(key, { volume: VOLUME[key] });
  }
}

export const soundManager = new SoundManager();

